<template>

  <div id="wrapper" class="">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <a class="small-header-action" href="">
            <div class="clip-header">
              <i class="fa fa-arrow-up"></i>
            </div>
          </a>

          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li><router-link :to="{name: 'ManageUsers'}">Manage Team</router-link></li>
              <li class="active">
                <span>Create User</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Create new User
          </h3>
          <small>Add new user</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="row">
        <div class="col-xs-12">
          <div class="hpanel">
            <div class="panel-heading">
              User Information
            </div>
            <div class="panel-body">
              <form v-on:submit="save" action="#" method="post">

                <div class="row">

                  <div class="col-xs-4">
                    <div class="form-group">
                      <label class="required">Gender
                        <span v-if="errorGender" class="error">{{ errorGender }}</span>
                      </label>

                      <v-select2 label="name" :options="genders" v-model="genderSelected"
                                 :class="{'has-error' : errorGender, 'has-success' : errorGender === false}"></v-select2>
                    </div>
                  </div>

                  <div class="col-xs-4">
                    <div class="form-group ">
                      <label for="last_name" class="required">Last Name
                        <span v-if="errorLastName" class="error">{{ errorLastName }}</span>
                      </label>
                      <input id="last_name" v-model="lastName" class="form-control" required :class="{'has-error' : errorLastName, 'has-success' : errorLastName === false}">
                    </div>
                  </div>

                  <div class="col-xs-4">
                    <div class="form-group ">
                      <label for="first_name" class="required">First Name
                        <span v-if="errorFirstName" class="error">{{ errorFirstName }}</span>
                      </label>
                      <input id="first_name" v-model="firstName" class="form-control" required :class="{'has-error' : errorFirstName, 'has-success' : errorFirstName === false}">
                    </div>
                  </div>

                </div>
                <div class="row">

                  <div class="col-xs-4">
                    <div class="form-group ">
                      <label for="phone" class="">Phone
                        <span v-if="errorPhone" class="error">{{ errorPhone }}</span>
                      </label>
                      <input id="phone" v-model="phone" class="form-control" :class="{'has-error' : errorPhone, 'has-success' : errorPhone === false}">
                    </div>
                  </div>

                  <div class="col-xs-4">
                    <div class="form-group ">
                      <label for="email" class="required">Email
                        <span v-if="errorEmail" class="error">{{ errorEmail }}</span>
                      </label>
                      <input id="email" v-model.trim="email" class="form-control" required :class="{'has-error' : errorEmail, 'has-success' : errorEmail === false}">
                    </div>
                  </div>

                  <div class="col-xs-4">
                    <div class="form-group ">
                      <label for="company_name" class="required">Company Name
                        <span v-if="errorCompany" class="error">{{ errorCompany }}</span>
                      </label>
                      <input id="company_name" v-model="companyName" class="form-control" required :class="{'has-error' : errorCompany, 'has-success' : errorCompany === false}">
                    </div>
                  </div>
                </div>

                <div class="row" style="margin-top: 15px">
                  <div class="col-xs-12">
                    <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info pull-right" :data-style="submit.dataStyle"> Create new User
                    </vue-ladda>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueLadda from 'vue-ladda'
import vSelect2 from '../../components/utils/select2'

export default {
  components: {
    VueLadda, vSelect2
  },
  name: 'CreateUser',
  props: [],
  data () {
    return {
      genders: [],
      lastName: null,
      firstName: null,
      email: null,
      companyName: null,
      genderSelected: null,
      phone: null,
      errorGender: null,
      errorFirstName: null,
      errorLastName: null,
      errorPhone: null,
      errorEmail: null,
      errorCompany: null,

      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }

    }
  },
  methods: {
    save: function (event) {
      event.preventDefault()

      this.submit.loading = true

      this.errorGender = null
      this.errorFirstName = null
      this.errorLastName = null
      this.errorPhone = null
      this.errorEmail = null
      this.errorCompany = null

      axios.post('/consultant/createUser', {
        last_name: this.lastName,
        first_name: this.firstName,
        email: this.email,
        company_name: this.companyName,
        phone: this.phone,
        gender_id: this.genderSelected != null ? this.genderSelected.id : null
      }).then((response) => {
        this.$notify({
          type: 'success',
          title: 'User created and attached',
          placement: 'bottom-right'
        })

        this.$router.push({name: 'ManageUser', params: {id: response.data.id}})
      }).catch((error) => {
        let errors = error.response.data.errors

        if (typeof errors['first_name'] !== 'undefined') {
          this.errorFirstName = errors['first_name'][0]
        } if (typeof errors['last_name'] !== 'undefined') {
          this.errorLastName = errors['last_name'][0]
        } if (typeof errors['gender_id'] !== 'undefined') {
          this.errorGender = errors['gender_id'][0]
        } if (typeof errors['email'] !== 'undefined') {
          this.errorEmail = errors['email'][0]
        } if (typeof errors['phone'] !== 'undefined') {
          this.errorPhone = errors['phone'][0]
        } if (typeof errors['company_name'] !== 'undefined') {
          this.errorCompany = errors['company_name'][0]
        }
      }).finally(() => {
        this.submit.loading = false
      })
    },
    getResources: function () {
      axios.get('/genders')
        .then((response) => {
          this.genders = response.data.map((gender) => {
            gender.text = gender.name
            return gender
          })
        })
        .catch(function (error) {
        })
    }

  },
  beforeMount () {
    this.getResources()
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/manageUsers/CreateUser.vue